<template>
  <div class="detail" name="Detail">
    <van-sticky>
      <van-nav-bar
        title="保险盒详情"
        color="#4065f4"
      >
        <template #left>
          <van-icon @click="goHome" name="arrow-left"/>
        </template>
      </van-nav-bar>
    </van-sticky>
    <van-tabs
      v-model="active"
      line-width="15%"
      swipe-threshold="2"
      v-if="typeList.length>0"
      color="#4065f4">
      <van-tab
        v-for="(item,index) in typeList"
        :title="item.fuseCategoryName"
        :name="item.fuseCategoryName"
        :key="index">
        <div class="detail-content">
          <viewer
            class="viewer"
            ref="viewer"
            :options="Options">
            <van-image
              :src="item.imageUrl"
              title="点击放大"
            >
              <template v-slot:loading>
                <van-loading type="spinner" size="20"/>
              </template>
            </van-image>
          </viewer>
          <div
            class="vant-table"
            v-bind:style="{height: height + 'px'}">
            <table
              style="width:100%"
              id="table"
              border="0"
              class="table"
              cellspacing="0"
              cellpadding="0">
              <thead>
              <tr>
                <th
                  v-for="(itemColumn, index) in option.column"
                  :key="index">
                  {{ itemColumn.label }}
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="(itemList, index) in item.fuseBoxPartIntrosList"
                :key="index"
                style="border-bottom: 1px solid #333;">
                <td
                  :rowspan="itemList.fusePartNospan"
                  :class="{hidden:itemList.fusePartNodis}">
                  {{ itemList.fusePartNo }}
                </td>
                <td>{{ itemList.fusePartNoName }}</td>
                <td>{{ itemList.fuseAmperes }}</td>
                <td>{{ itemList.fuseComments }}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>

import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import Vue from 'vue';
import {axios} from '../utils/request';
import {JSON_URL} from '../configs/base';

Vue.use(Viewer);


export default {
  name: 'detail.vue',
  data() {
    return {
      option: {
        column: [
          {label: '保险丝号码', prop: 'fusePartNo'},
          {label: '名称', prop: 'fusePartNoName'},
          {label: '安培值(A)', prop: 'fuseAmperes'},
          {label: '说明', prop: 'fuseComments'}
        ]
      },
      active: '',
      typeList: [],
      Options: {
        'inline': false,
        'button': true, //右上角按钮
        'navbar': false, //底部缩略图
        'title': false, //当前图片标题
        'toolbar': true, //底部工具栏
        'tooltip': true, //显示缩放百分比
        'movable': true, //是否可以移动
        'zoomable': true, //是否可以缩放
        'rotatable': true, //是否可旋转
        'scalable': false, //是否可翻转
        'transition': false, //使用 CSS3 过度
        'fullscreen': false, //播放时是否全屏
        'keyboard': true //是否支持键盘
      },
      window: {
        // width: document.body.clientWidth,
        height: window.innerHeight
      },
      height: '',
      path: '',
      loaded: true
    };
  },
  mounted() {
    this.init();
  },
  created() {
    this.initWindow();
  },
  methods: {
    init() {
      this.active = this.$router.currentRoute.query.id;
      this.path = this.$router.currentRoute.query.path;
      this.getData(this.path);
    },
    // 实时获取页面宽度
    initWindow() {
      this.height = this.window.height - 90 - 270;
    },
    // 返回主页
    goHome() {
      this.$router.push({
        name: 'Home'
      });
    },
    // 请求的数据
    getData(id) {
      const timestamp = new Date().getTime();
      // let url = `fushjsonfile/${id.toLocaleLowerCase()}.json`;
      // let url = `api/fuseboxjson/${id}.json`;
      let url = JSON_URL + `${id}.json` + '?' + timestamp;
      axios.get(url).then(res => {
        this.typeList = res.data;
        if (this.typeList) {
          this.typeList.forEach(val => {
            if (val.fuseBoxPartIntrosList) {
              this.combineCell(val.fuseBoxPartIntrosList);
              val.fuseBoxPartIntrosList.forEach(valArr => {
                if (valArr.fuseAmperes === 0) {
                  valArr.fuseAmperes = '';
                }
              });
            }
          });
        }
      });
    },
    // 表格合并处理
    combineCell(list) {
      for (var field in list[0]) {
        var k = 0;
        while (k < list.length) {
          list[k][field + 'span'] = 1;
          list[k][field + 'dis'] = false;
          for (var i = k + 1; i <= list.length - 1; i++) {
            if (list[k][field] == list[i][field] && list[k][field] != '') {
              list[k][field + 'span']++;
              list[k][field + 'dis'] = false;
              list[i][field + 'span'] = 1;
              list[i][field + 'dis'] = true;
            } else {
              break;
            }
          }
          k = i;
        }
      }
      return list;
    }
  }
};
</script>

<style lang="less">
.detail {
  .van-sticky {
    .van-nav-bar {
      background: #4065f4;

      .van-nav-bar__title {
        font-size: 18px;
        font-weight: 600;
        color: #fff;
      }

      .van-nav-bar__left {
        .van-icon {
          font-size: 18px;
          color: #fff;
        }
      }
    }
  }

  .van-tabs {
    .van-tabs__wrap .van-tabs__nav .van-tab {
      font-size: 16px;
    }

    .van-tabs__content .van-tab__pane .detail-content {
      .viewer {
        .van-image {
          width: 100%;
          height: 260px;
          display: flex;
          justify-content: center;

          .van-image__img {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
          }
        }
      }

      .vant-table {
        margin-top: 10px;
        overflow-x: auto;

        #table {
          font-size: 13px;
          text-align: center;
          table-layout: fixed;

          th,
          td {
            padding: 0 1px;
            word-break: break-word;
            line-height: 30px;
            text-align: center;
            border-left: 1px solid #84C8FB;
            border-bottom: 1px solid #84C8FB;
          }

          th:nth-child(1), td:nth-child(1) {
            width: 20%;
          }

          th:nth-child(2), td:nth-child(2) {
            width: 44%;
          }

          th:nth-child(3), td:nth-child(3) {
            width: 18%;
          }

          th:nth-child(4), td:nth-child(4) {
            width: 20%;
            border-right: 1px solid #84C8FB;
          }

          th {
            background-color: #84C8FB;
            position: sticky;
            top: 0px;
            height: 40px;
          }

          td:first-child {
            position: sticky;
            left: 0px;
          }

          th:first-child {
            position: sticky;
            left: 0px;
            top: 0px;
            z-index: 10;
          }
        }
      }
    }
  }
}

.viewer-container {
  height: 570px;
  top: -210px !important;

  .viewer-footer {
    bottom: -5px;

    .viewer-toolbar {
      li::before {
        width: 30px;
        height: 30px;
        background-size: 400px;
      }

      li {
        margin: 0 5px;
        width: 30px;
        height: 30px;
      }

      .viewer-zoom-in::before {
        background-position: -2px -1px;
      }

      .viewer-zoom-out::before {
        background-position: -30px -1px;
      }

      .viewer-reset::before {
        background-position: -87px -1px;
      }

      .viewer-play::before {
        background-position: -146px -3px;
      }

      .viewer-rotate-left::before {
        background-position: -201px -1px;
      }

      .viewer-rotate-right::before {
        background-position: -228px -2px;
      }

      .viewer-one-to-one, .viewer-prev, .viewer-next, .viewer-large {
        display: none;
      }
    }
  }

  .viewer-canvas {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 10px;
  }

  .viewer-button {
    top: 165px;
  }
}

.hidden {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/detail.vue